export default {
  SEARCH_CATALOG_ALLIANZ_ACTIVITY_QUERY: Symbol.for('SEARCH_CATALOG_ALLIANZ_ACTIVITY_QUERY'),
  CATALOG_ALLIANZ_ACTIVITY_REPOSITORY: Symbol.for('CATALOG_ALLIANZ_ACTIVITY_REPOSITORY'),
  CATALOG_ALLIANZ_ACTIVITY_STATE_MANAGER: Symbol.for('CATALOG_ALLIANZ_ACTIVITY_STATE_MANAGER'),
};
